import { render, staticRenderFns } from "./DivisionTypeText.vue?vue&type=template&id=4ed30b4e&"
import script from "./DivisionTypeText.vue?vue&type=script&lang=js&"
export * from "./DivisionTypeText.vue?vue&type=script&lang=js&"
import style0 from "./DivisionTypeText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DivisionTypeText.vue"
export default component.exports